// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanContributionDto } from './IPlanContributionDto';
import {
    IPlanContributionDtoFromJSON,
    IPlanContributionDtoFromJSONTyped,
    IPlanContributionDtoToJSON,
    IPlanContributionDtoToJSONTyped,
} from './IPlanContributionDto';

/**
 * 
 * @export
 * @interface IEmployeeContributionDto
 */
export interface IEmployeeContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeContributionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeContributionDto
     */
    is_new_employee?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeContributionDto
     */
    employee_termination_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeContributionDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeContributionDto
     */
    last_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IEmployeeContributionDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeContributionDto
     */
    is_subsidiary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeContributionDto
     */
    organization_name?: string;
    /**
     * 
     * @type {Array<IPlanContributionDto>}
     * @memberof IEmployeeContributionDto
     */
    plans?: Array<IPlanContributionDto>;
}

/**
 * Check if a given object implements the IEmployeeContributionDto interface.
 */
export function instanceOfIEmployeeContributionDto(value: object): value is IEmployeeContributionDto {
    return true;
}

export function IEmployeeContributionDtoFromJSON(json: any): IEmployeeContributionDto {
    return IEmployeeContributionDtoFromJSONTyped(json, false);
}

export function IEmployeeContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'is_new_employee': json['is_new_employee'] == null ? undefined : json['is_new_employee'],
        'employee_termination_date': json['employee_termination_date'] == null ? undefined : (new Date(json['employee_termination_date'])),
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'is_subsidiary': json['is_subsidiary'] == null ? undefined : json['is_subsidiary'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanContributionDtoFromJSON)),
    };
}

export function IEmployeeContributionDtoToJSON(json: any): IEmployeeContributionDto {
    return IEmployeeContributionDtoToJSONTyped(json, false);
}

export function IEmployeeContributionDtoToJSONTyped(value?: IEmployeeContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'is_new_employee': value['is_new_employee'],
        'employee_termination_date': value['employee_termination_date'] == null ? undefined : ((value['employee_termination_date']).toISOString()),
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'is_subsidiary': value['is_subsidiary'],
        'organization_name': value['organization_name'],
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanContributionDtoToJSON)),
    };
}

